"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("../../styles");
var Loader_1 = __importDefault(require("./Loader"));
function SmallLabel(_a) {
    var children = _a.children, style = _a.style, _b = _a.loading, loading = _b === void 0 ? false : _b, _c = _a.className, className = _c === void 0 ? "" : _c;
    return ((0, jsx_runtime_1.jsxs)(StyledContainer, __assign({ style: style, className: "twap-small-label ".concat(className) }, { children: [loading && ((0, jsx_runtime_1.jsx)(material_1.Fade, __assign({ in: loading }, { children: (0, jsx_runtime_1.jsx)(StyledLoader, __assign({ className: "twap-small-label-loader" }, { children: (0, jsx_runtime_1.jsx)(Loader_1.default, { width: "100%", height: "100%" }) })) }))), !loading && ((0, jsx_runtime_1.jsx)(material_1.Fade, __assign({ in: !loading }, { children: (0, jsx_runtime_1.jsx)(StyledChildren, { children: children }) })))] })));
}
exports.default = SmallLabel;
var StyledChildren = (0, material_1.styled)(styles_1.StyledOneLineText)({
    fontSize: "inherit",
    fontFamily: "inherit",
});
var StyledLoader = (0, material_1.styled)(material_1.Box)({
    width: 50,
    height: 20,
});
var StyledContainer = (0, material_1.styled)(material_1.Box)({
    position: "relative",
    display: "flex",
    alignItems: "center",
});
